<ng-container *ngIf="!scope.config.disableSignIn; else showNoAccessMsg">
  <div class="login-hero">
    <div class="login-hero__inner">
      <h1 class="login-hero__title" [innerText]="scope.getText | transform:'LOGIN'"></h1>
    </div>
  </div>
  <div class="login-body">
    <div class="login-card">
      <app-error-summary [error]="scope.error" *ngIf="scope.error"></app-error-summary>
      <div [ngClass]="{'disabled--loading': scope.loading}">
        <dynamic-form (submit)="scope.submitForm($event)" [fields]="scope.loginConfig"></dynamic-form>
        <div class="login-card__actions" disabledDiv>
          <button class="login-card__forgot" mat-stroked-button
            (click)="scope.forgotPassword()">{{scope.getText | transform:'FORGOT_PASSWORD?'}}</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #showNoAccessMsg>
  <div class="login-hero">
    <div class="login-hero__inner">
      <h1 class="login-hero__title">{{scope.getText | transform:'PAGE_NO_ACCESS_MSG'}}</h1>
    </div>
  </div>
</ng-template>
